import { render } from "./CommercialInsurancePage.vue?vue&type=template&id=1cd89f41"
import script from "./CommercialInsurancePage.vue?vue&type=script&lang=js"
export * from "./CommercialInsurancePage.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__